import { handleApiResponse, notify } from '@/functions';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IPaymentProvider } from '@/interfaces/paymentProvider.interface';

type TVariables = {
  operatorKey: string;
  dto: Partial<Omit<IPaymentProvider, 'provider'>>;
};

export const useRequestUpdatePaymentOperator = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.paymentProviders, 'update'],
    mutationFn: ({ operatorKey, dto }: TVariables) =>
      apiClient
        .put<void>(routes.api.updatePaymentOperator(operatorKey), dto)
        .then(handleApiResponse)
        .catch(error => {
          notify(error?.internalMessage, 'error');
          throw error;
        }),
    onSuccess: () => {
      invalidate(routes.api.paymentProviders);
      notify('Opérateur mis à jour', 'success');
    }
  });

  return ({
    isLoadingUpdatePaymentOperator: isPending,
    triggerUpdatePaymentOperator: (variables: TVariables) => mutateAsync(variables),
    error
  });

};
